// Sweden products are Thrillophilia imports only; Scandinavia combos are listed on every Nordic country they visit.
import { swedenNorthernLightsSafariProduct } from './swedenNorthernLightsSafariData';
import { swedenNorthernLightsDinnerOnIceProduct } from './swedenNorthernLightsDinnerOnIceData';
import { scandinaviaGroupTourHelsinkiCopenhagenProduct } from './scandinaviaGroupTourHelsinkiCopenhagenData';
import { scandinaviaClassicFlamRailwayProduct } from './scandinaviaClassicFlamRailwayData';

export const swedenProducts = [
  swedenNorthernLightsSafariProduct,
  swedenNorthernLightsDinnerOnIceProduct,
  scandinaviaGroupTourHelsinkiCopenhagenProduct,
  scandinaviaClassicFlamRailwayProduct
];
export const swedenTours = [];
export const swedenBySlug = {};
